import { useMemo, useState } from 'react';
import { resetPassword, isStrongPassword } from '../api/auth/auth';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';

export default function ResetPassword() {
    const [sp] = useSearchParams();
    const token = useMemo(() => sp.get('token') || '', [sp]);
    const [pw, setPw] = useState('');
    const [pw2, setPw2] = useState('');
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState<string | null>(null);
    const [ok, setOk] = useState(false);
    const navigate = useNavigate();

    const submit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (loading) return;
        setErr(null);

        if (!token) { setErr('Brak tokenu resetu w adresie URL.'); return; }
        if (pw !== pw2) { setErr('Hasła nie są identyczne.'); return; }
        if (!isStrongPassword(pw)) {
            setErr('Hasło: min. 8 znaków, co najmniej 1 wielka litera i 1 cyfra.');
            return;
        }

        setLoading(true);
        try {
            await resetPassword(token, pw);
            setOk(true);
            setTimeout(() => navigate('/admin/login', { replace: true }), 1200);
        } catch (e: any) {
            setErr(e.message || 'Nie udało się zresetować hasła.');
        } finally {
            setLoading(false);
        }
    };

    if (ok) {
        return (
            <main className="login-wrap">
                <section className="login-card">
                    <h1>Hasło zmienione</h1>
                    <p>Możesz się teraz <Link to="/admin/login">zalogować</Link>.</p>
                </section>
            </main>
        );
    }

    return (
        <main className="login-wrap">
            <section className="login-card">
                <h1>Ustaw nowe hasło</h1>
                <form onSubmit={submit} className="login-form" noValidate>
                    <label className="login-label">
                        Nowe hasło
                        <input className="login-input" type="password" value={pw}
                            onChange={(e) => setPw(e.target.value)} placeholder="Min. 8 znaków, 1 wielka litera i 1 cyfra" required />
                    </label>
                    <label className="login-label">
                        Powtórz hasło
                        <input className="login-input" type="password" value={pw2}
                            onChange={(e) => setPw2(e.target.value)} required />
                    </label>
                    {err && <p style={{ color: '#b91c1c' }}>{err}</p>}
                    <button className="login-button" type="submit" disabled={loading}>
                        {loading ? 'Zapisywanie…' : 'Zmień hasło'}
                    </button>
                </form>
            </section>
        </main>
    );
}
